







































import { Vue, Component, Prop } from 'vue-property-decorator';
import { NaviItem, NaviResult, SystemService } from '@/api/system-service';
import vuetify from '../plugins/vuetify';
import { authState } from '../store/modules/auth-state';
import { pdfState } from '../store/modules/pdf-state';

// interface NaviItem {
//   param: string;
//   text: string;
// }

@Component
export default class Navi extends Vue {
  pdfUrl: string = '';

  title: string = '';

  list: NaviItem[] = [];

  // list: NaviItem[] = [
  //   {
  //     param: '%5B%7B%22num%22%3A23050%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C0%2C429%2C0%5D',
  //     text: '警察小六法',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A24501%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C0%2C429%2C0%5D',
  //     text: 'はしがき',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A24504%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C0%2C429%2C0%5D',
  //     text: '凡例',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A4%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C0%2C420%2C0%5D',
  //     text: '目次',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A24408%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2C0%2C429%2C0%5D',
  //     text: '法令名索引',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A60%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '憲法・公法編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A2709%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '警察組織・警察官職務編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A3421%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '警務・犯罪者処遇編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A4266%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '地域編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A4550%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '刑事編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A9517%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '組対編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A11313%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '生活安全編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A14663%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '警備編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A14794%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '公安編',
  //   },
  //   {
  //     param: '%5B%7B%22num%22%3A15385%2C%22gen%22%3A0%7D%2C%7B%22name%22%3A%22XYZ%22%7D%2Cnull%2C402.51968%2Cnull%5D',
  //     text: '交通編',
  //   },
  // ]

  async mounted() {
    const naviResult = await SystemService.getNavi();
    this.title = naviResult.title;
    this.list = naviResult.item;
  }

  pdfClick(pdfParams: string) {
    const routeData = this.$router.resolve({
      name: 'pdf',
      params: { pdfParams },
    });
    window.open(routeData.href, '_blank');
  }
}
